<div class="dialog-content-wrapper">
    <mat-toolbar class="mat-primary m-0">
        <mat-toolbar-row
            fxFlex
            fxLayout="row"
            fxLayoutAlign="space-between center"
        >
            <span class="title dialog-title text-truncate">Documentos</span>
            <button
                mat-icon-button
                (click)="dialogRef.close()"
                aria-label="Close dialog"
            >
                <mat-icon>close</mat-icon>
            </button>
        </mat-toolbar-row>
    </mat-toolbar>

    <mat-dialog-content class="p-16 pb-0 m-0">
        <form
                class="form"
                [formGroup]="formulario"
                autocomplete="off"
                class="mt-16"
            >
        <mat-form-field class="full-width">
            <mat-label>Tipo</mat-label>
            <mat-select formControlName="tipo">
                <mat-option
                    *ngFor="let t of data.tipos"
                    [value]="t.id"
                >
                    {{ t.descripcion }}
                </mat-option>
            </mat-select>
        </mat-form-field>
        <mat-form-field class="pr-sm-8" class="full-width">
            <mat-label>Fecha</mat-label>
            <input
                matInput
                [matDatepicker]="fechaDatePicker"
                name="fecha"
                formControlName="fecha"
                
            />
            <mat-datepicker-toggle
                matSuffix
                [for]="fechaDatePicker"
            ></mat-datepicker-toggle>
            <mat-datepicker #fechaDatePicker></mat-datepicker>
            <mat-error *ngIf="fecha.hasError('required')">
                Debe ingresar la fecha de vencimiento
            </mat-error>
        </mat-form-field>

        <div class="file-uploader">
            <input
                hidden
                type="file"
                #fileInput
                formControlName="documento"
                (change)="getFile($event.target.files)"
            />
            <button
                mat-button
                *ngIf="documento && !documento.value"
                color="primary"
                class="add-file-button"
                (click)="fileInput.click()"
                aria-label="Adjuntar archivo"
                [@animate]="{
                    value: '*',
                    params: { delay: '300ms', scale: '0.2' }
                }"
            >
                <mat-icon>note_add</mat-icon>
                Adjuntar archivo
            </button>

            <button
                mat-button
                *ngIf="documento && documento.value"
                (click)="documento.setValue(null)"
                aria-label="Adjuntar archivo"
                [@animate]="{
                    value: '*',
                    params: { delay: '300ms', scale: '0.2' }
                }"
            >
                <small>{{ documento.value }}</small>
                <mat-icon color="warn">delete_forever</mat-icon>
            </button>
            <mat-error *ngIf="documento.errors?.error_file_size">
                El documento no puede ser mayor a 2 MB
            </mat-error>
        </div>

        </form>
    </mat-dialog-content>

    <mat-dialog-actions
        class="m-0 p-16"
        fxLayout="row"
        fxLayoutAlign="end center"
    >
        <button mat-button mat-dialog-close>Cancelar</button>
        <button
            mat-raised-button
            color="accent"
            (click)="guardar()"
            [disabled]="!formulario.valid"
        >
            Guardar
        </button>
    </mat-dialog-actions>
</div>
